export { AccordionComponent } from './accordion.component';
export { AccordionPanelComponent } from './accordion-panel.component';
export { L_AccordionModule } from './accordion.module';



// WEBPACK FOOTER //
// ./.tmp/accordion/index.ts